import { onMounted, onUnmounted } from 'vue'

export function useFadeInObserver() {
  let observer = null

  const initObserver = () => {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, { threshold: 0.1 })

    const fadeElems = document.querySelectorAll('.fade-in')
    fadeElems.forEach(elem => observer.observe(elem))
  }

  const cleanupObserver = () => {
    if (observer) {
      observer.disconnect()
    }
  }

  onMounted(() => {
    initObserver()
  })

  onUnmounted(() => {
    cleanupObserver()
  })

  return {
    initObserver,
    cleanupObserver
  }
}